"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var InfiniteScrollDirective = (function () {
    function InfiniteScrollDirective() {
        this.infiniteScroll = new core_1.EventEmitter();
    }
    InfiniteScrollDirective.prototype.scroll = function ($event) {
        if (Math.round($event.target.scrollTop + $event.target.clientHeight) >= $event.target.scrollHeight) {
            this.infiniteScroll.emit();
        }
    };
    InfiniteScrollDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[infiniteScroll]'
                },] },
    ];
    InfiniteScrollDirective.ctorParameters = function () { return []; };
    InfiniteScrollDirective.propDecorators = {
        "infiniteScroll": [{ type: core_1.Output },],
        "scroll": [{ type: core_1.HostListener, args: ['scroll', ['$event'],] },],
    };
    return InfiniteScrollDirective;
}());
exports.InfiniteScrollDirective = InfiniteScrollDirective;
//# sourceMappingURL=infinite-scroll.directive.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ng-infinitescroll/dist/infinite-scroll.directive.js
// module id = ../../../../ng-infinitescroll/dist/infinite-scroll.directive.js
// module chunks = vendor